import RenderHTML from '../../../../components/ui-components/RenderHTML'
import { PrimaryButton } from '../../../../components/execution/PrimaryButton'
import { postCTA } from '../../../../utils/appBridge'
import { getEliteCTA } from '../../../../utils/mutualFundDetail'
import { LockIcon } from '../LockIcon'
import {
  TaxHarvestingScreenName,
  TaxHarvestingEventId,
  TaxHarvestingButtonLabel,
  trackTaxHarvestingButtonTap
} from '../../tracking/taxHarvestingTracking'

const ELITE_BENEFITS = [
  'Unlock full breakup of capital gains & taxes',
  'Get quarterly advance tax reminders all year',
  'Get a year-end personalised tax saving plan'
]

export function TaxSummaryLockedCard() {
  const handleUnlockClick = () => {
    trackTaxHarvestingButtonTap({
      screen: TaxHarvestingScreenName.Summary,
      eventId: TaxHarvestingEventId.UnlockEliteOverlay,
      buttonLabel: TaxHarvestingButtonLabel.UnlockPlanWithElite
    })
    postCTA(JSON.stringify(getEliteCTA()))
  }

  return (
    <div className='relative z-10 flex w-full flex-col items-center'>
      <RenderHTML innerHTMLText={LockIcon} />
      <p className='mt-4 text-center text-lg font-[500] leading-[1.4] text-[#992E00]'>
        Stay on top of your taxes
      </p>
      <ul className='mt-4 flex w-full max-w-[286px] flex-col gap-2'>
        {ELITE_BENEFITS.map((benefit) => (
          <li key={benefit} className='flex items-start gap-2'>
            <span className='mt-[2px] flex-shrink-0'>
              <BlackCheckIcon />
            </span>
            <span className='text-[13px] font-[400] leading-[1.5] text-[#232323]'>{benefit}</span>
          </li>
        ))}
      </ul>
      <div className='mt-6 w-full max-w-[286px] mx-auto flex justify-center'>
        <PrimaryButton
          onClick={handleUnlockClick}
          label='Unlock with Elite'
          primaryButtonClassName='!h-[36px] !rounded-lg text-[14px] !p-0 !px-4 !w-auto'
        />
      </div>
    </div>
  )
}

export function BlackCheckIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M3 8.5L6.5 12L13 4'
        stroke='#232323'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
